<template>
  <div class="report">
    <Header :title="title" :right-content="rightContent" @flashList="flashReportList" />
    <div id="content" :class="pageType == 'app'?'isApp':''">
      <div class="layout">
        <div v-if="pageType != 'app'" id="reportName" class="reportName">
          <!-- <div class="itemBgColor" id="itemBgColor"></div>
                    <div class="slideCon" id="slideCon"><span v-for="(item,index) in reportName" @click="clickTab(index)" :class="{'checked':tabIndex==index}">{{item.name}}</span> -->
          <div class="nav-wrap">
            <div id="slideCon" class="slideCon"><span v-for="(item,index) in reportName" :class="{'checked':tabIndex==index}" @click="clickTab(index)">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--刷选-->
      <div v-if="isBrushTradePop" class="brushPop">
        <div class="brushCon">
          <div class="reportTit">
            <SelectAccount />
            <a @click="blushConditionPop">其他条件查询</a>
          </div>
          <div class="inputCon">
            <span>订单号</span>
            <input v-model="idTxt" type="number" :placeholder="idTxt" onkeyup="(this.v=function(){this.value=this.value.replace(/[^\d]/g,'');}).call(this)" onblur="this.v();">
          </div>
          <div class="btn">
            <span @click="submit(0)">重置</span>
            <span @click="submit(1)">确定</span>
          </div>
        </div>
      </div>
      <!--交易记录-->
      <TradeRecord v-if="tabIndex==0||(typeName=='trades'&&typeName!='')" :trade="trade" :is-brush-trade-pop="isBrushTradePop" @blushPop="blushPop" />
      <!--委托记录-->
      <EntrustRecord v-if="tabIndex==1||(typeName=='order'&&typeName!='')" :entrust="entrust" :is-brush-trade-pop="isBrushTradePop" @blushPop="blushPop" />
      <!--盈亏记录-->
      <ProfitAndLossRecord v-if="tabIndex==2||(typeName=='profit'&&typeName!='')" :profit-and-loss="profitAndLoss" :is-brush-trade-pop="isBrushTradePop" @blushPop="blushPop" />
      <!--额度记录-->
      <CreditRecord v-if="tabIndex==3||(typeName=='balance'&&typeName!='')" :credit="credit" :is-brush-trade-pop="isBrushTradePop" @blushPop="blushPop" />
      <!--止盈止损记录-->
      <StopLossRecord v-if="tabIndex==4||(typeName=='stoploss'&&typeName!='')" :stop="stop" :stop-ac-i-d="stopAcID" :is-brush-trade-pop="isBrushTradePop" @blushPop="blushPop" />
      <div class="more" :class="moreClass" @click="clickMore"><span>{{ moreTxt }}</span></div>
    </div>
    <!--刷选弹窗-->
    <ReportCondition v-if="isReportCondition" :is-report-condition="isReportCondition" :platform-name="platformName" :direction="direction" :order-type="orderType" :symbol="symbol" :data-condition="dataCondition" @changeConditionPop="changeConditionPop" @changeBlushPop="changeBlushPop" @report="report" />
    <div id="bottomRight">
      <img id="topBtn" src="@/assets/images/template/toolbar_top.png">
    </div>
  </div>
</template>

<script>
require('swiper/css/swiper.css')
require('@/assets/css/report.css')
import Header from '@/view/module/Header.vue'
import TradeRecord from '@/view/report/TradeRecord.vue'
import EntrustRecord from '@/view/report/EntrustRecord.vue'
import ProfitAndLossRecord from '@/view/report/ProfitAndLossRecord.vue'
import CreditRecord from '@/view/report/CreditRecord.vue'
import StopLossRecord from '@/view/report/StopLossRecord.vue'
import ReportCondition from '@/view/report/ReportCondition.vue'
import api from '@/plugins/api'
import utils from '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
import SelectAccount from '@/view/module/SelectAccount.vue'

export default {
  name: 'Report',
  components: { Header, TradeRecord, EntrustRecord, ProfitAndLossRecord, CreditRecord, ReportCondition, StopLossRecord, SelectAccount },
  computed: {
    ...mapState(['tabIndex', 'platform', 'pageType', 'gts2AccountId', 'platformName', 'tradeCondition', 'entrustCondition', 'profitAndLossCondition', 'creditCondition', 'stopCondition']),
    moreClass: {
      get() {
        let classType = ''
        if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) {
          if (this.trade.recordList) {
            if (this.trade.recordList.length >= 10 && this.trade.totalPage > 1) {
              this.moreTxt = '加载更多'
              classType = ''
            } else {
              if (this.trade.totalSize == 0) this.moreTxt = ''
              else this.moreTxt = '没有更多数据'
              classType = 'noData'
            }
            return classType
          }
        }
        if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) {
          if (this.entrust.recordList) {
            if (this.entrust.recordList.length >= 10 && this.entrust.totalPage > 1) {
              this.moreTxt = '加载更多'
              classType = ''
            } else {
              if (this.entrust.totalSize == 0) this.moreTxt = ''
              else this.moreTxt = '没有更多数据'
              classType = 'noData'
            }
            return classType
          }
        }
        if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) {
          if (this.profitAndLoss.recordList) {
            if (this.profitAndLoss.recordList.length >= 10 && this.profitAndLoss.totalPage > 1) {
              this.moreTxt = '加载更多'
              classType = ''
            } else {
              if (this.profitAndLoss.totalSize == 0) this.moreTxt = ''
              else this.moreTxt = '没有更多数据'
              classType = 'noData'
            }
            return classType
          }
        }
        if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) {
          if (this.credit.recordList) {
            if (this.credit.recordList.length >= 10 && this.credit.totalPage > 1) {
              this.moreTxt = '加载更多'
              classType = ''
            } else {
              if (this.credit.totalSize == 0) this.moreTxt = ''
              else this.moreTxt = '没有更多数据'
              classType = 'noData'
            }
            return classType
          }
        }
        if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) {
          if (this.stop.recordList) {
            if (this.stop.recordList.length >= 10 && this.stop.totalPage > 1) {
              this.moreTxt = '加载更多'
              classType = ''
            } else {
              if (this.stop.totalSize == 0) this.moreTxt = ''
              else this.moreTxt = '没有更多数据'
              classType = 'noData'
            }
            return classType
          }
        }
        return ''
      }
    }
  },
  data() {
    return {
      title: '交易记录',
      rightContent: 'report',
      slideIndex: '',
      moreTxt: '',
      reportName: [
        { name: '交易记录', id: '0' },
        { name: '委托记录', id: '1' },
        { name: '盈亏记录', id: '2' },
        { name: '额度记录', id: '3' },
        { name: '止盈止损记录', id: '4' }
      ],
      beginTime: utils.getLast1Month(new Date()).beginTime.replace(/\//gi, '-'),
      endTime: utils.getLast1Month(new Date()).endTime.replace(/\//gi, '-'),
      trade: '', // 交易记录列表
      tradeNum: 10,
      entrust: '', // 委托记录列表
      entrustNum: 10,
      profitAndLoss: '', // 盈亏记录列表
      profitAndLossNum: 10,
      credit: '', // 额度记录列表
      creditNum: 10,
      stop: '', // 止盈止损记录列表
      stopNum: 10,
      stopAcID: '',
      isBrushTradePop: false, // 刷选弹窗
      isReportCondition: false, // 其他条件弹窗
      direction: '', // 反向
      orderType: '', // 交易订单类型
      symbol: '', // 产品列表
      idTxt: '请输入订单号', // 订单号
      bushData: '',
      dataCondition: '',
      typeName: this.$route.query.typeName || '',
      typeIndex: this.$route.query.typeIndex || ''
    }
  },
  watch: {
    slideIndex: {
      deep: true,
      handler(newValue, oldValue) {
        this.$store.dispatch('setTabIndex', newValue)
        if (newValue != oldValue) {
          this.isBrushTradePop = false
          const options = {
            timeNum: 2,
            checkTime: utils.getLast1Month(new Date()).beginTime.replace(/\//gi, '-'),
            checkEndTime: utils.getLast1Month(new Date()).endTime.replace(/\//gi, '-'),
            checkTimeTxt: '一个月',
            checkType: 'all',
            checkTradeType: 'all',
            typeNum: 'all',
            tradeNum: 'all',
            checkDirection: 'all',
            directionNum: 'all',
            checkSymbol: 'all',
            symbolNum: 'all',
            selectedTradeTypes: [{ code: 'all', text: '所有' }],
            volumeVal: null
          }
          if (newValue == 0) this.$store.dispatch('setTradeCondition', options)
          if (newValue == 1) this.$store.dispatch('setEntrustCondition', options)
          if (newValue == 2) this.$store.dispatch('setProfitAndLossCondition', options)
          if (newValue == 3) this.$store.dispatch('setCreditCondition', options)
          if (newValue == 4) this.$store.dispatch('setStopCondition', options)
        }
      }
    }
  },
  beforeCreate() {
    if (this.pageType == 'app') this.$store.dispatch('setTabIndex', -1)
    const options = {
      timeNum: 2,
      checkTime: utils.getLast1Month(new Date()).beginTime.replace(/\//gi, '-'),
      checkEndTime: utils.getLast1Month(new Date()).endTime.replace(/\//gi, '-'),
      checkTimeTxt: '一个月',
      checkType: 'all',
      checkTradeType: 'all',
      typeNum: 'all',
      tradeNum: 'all',
      checkDirection: 'all',
      directionNum: 'all',
      checkSymbol: 'all',
      symbolNum: 'all',
      selectedTradeTypes: [{ code: 'all', text: '所有' }],
      volumeVal: null
    }
    if (!this.tradeCondition) {
      this.$store.dispatch('setTradeCondition', options)
    }
    if (!this.entrustCondition) {
      this.$store.dispatch('setEntrustCondition', options)
    }
    if (!this.profitAndLossCondition) {
      this.$store.dispatch('setProfitAndLossCondition', options)
    }
    if (!this.creditCondition) {
      this.$store.dispatch('setCreditCondition', options)
    }
    if (!this.stopCondition) {
      this.$store.dispatch('setStopCondition', options)
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.goTop()
    this.report(0)
    this.initCondition()
    if (this.pageType == 'app') {
      this.$store.dispatch('setTabIndex', -1)
    } else {
      if (!this.tabIndex) this.$store.dispatch('setTabIndex', 0)
      if (this.typeIndex != '') this.$store.dispatch('setTabIndex', this.typeIndex)
    }
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.goTop()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    goTop() {
      const backTop = document.getElementById('topBtn')
      window.onscroll = function() {
        const scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        if (scroll >= 300) {
          backTop.classList.add('show')
        } else {
          backTop.classList.remove('show')
        }
      }
      backTop.addEventListener('click', function() {
        document.documentElement.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      })
    },
    clickTab(index) {
      this.removeFixed()
      this.slideIndex = index
      this.$store.dispatch('setTabIndex', index)
      if (index == 3) {
        document.getElementById('slideCon').scrollLeft = 100
        // document.getElementById("itemBgColor").classList.add("rightRadius");
        document.getElementById('reportName').classList.add('paddingLeft')
      } else if (index === 4) {
        document.getElementById('slideCon').scrollLeft = 150
        document.getElementById('reportName').classList.add('paddingLeft')
      } else {
        document.getElementById('slideCon').scrollLeft = 0
        // document.getElementById("itemBgColor").classList.remove("rightRadius");
        document.getElementById('reportName').classList.remove('paddingLeft')
      }
    },
    report(data) { // data值：0是初始，1是刷新，2是订单号查询，其他是其他条件查询
      this.bushData = data
      let options
      options = {
        index: 1,
        pageSize: 10,
        beginTime: this.beginTime,
        endTime: this.endTime,
        platform: this.platform
      }
      if (data == 0) {
        this.getTradeRecord(options)
        this.getEntrustRecord(options)
        this.getProfitAndLossRecord(options)
        this.getCreditRecord(options)
        this.getStopLossRecordList(options)
      } else {
        if (data == 1) {
          // options = options
        } else if (data == 2) {
          options = {
            index: 1,
            pageSize: 10,
            beginTime: this.beginTime,
            endTime: this.endTime,
            platform: this.platform,
            orderId: this.idTxt
          }
        } else {
          options = data
        }
        if ('beginTime' in options) {
          options.beginTime = options.beginTime.replace(/\//gi, '-')
        }
        if ('endTime' in options) {
          options.endTime = options.endTime.replace(/\//gi, '-')
        }
        if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) this.getTradeRecord(options)
        if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) this.getEntrustRecord(options)
        if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) this.getProfitAndLossRecord(options)
        if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) this.getCreditRecord(options)
        if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) this.getStopLossRecordList(options)
      }
    },
    getTradeRecord(data) {
      api.tradeRecord(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.trade = res.data.data
          }
        }
      })
    },
    getEntrustRecord(data) {
      api.entrustRecord(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.entrust = res.data.data
          }
        }
      })
    },
    getProfitAndLossRecord(data) {
      api.profitAndLossRecord(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.profitAndLoss = res.data.data
          }
        }
      })
    },
    getCreditRecord(data) {
      api.creditRecord(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.credit = res.data.data
          }
        }
      })
    },
    getStopLossRecordList(data) {
      api.stopLossRecordList(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.$bus.$emit('loading', true)
            this.stop = res.data.data
            this.stopAcID = this.gts2AccountId
          }
        }
      })
    },
    clickMore() {
      let data = {}
      if (this.moreTxt == '加载更多') {
        if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) {
          this.tradeNum += 10
          if (this.bushData == 0 || this.bushData == 1) {
            data = {
              index: 1,
              pageSize: this.tradeNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform
            }
          } else if (this.bushData == 2) {
            data = {
              index: 1,
              pageSize: this.tradeNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform,
              orderId: this.idTxt
            }
          } else {
            data = {
              index: 1,
              pageSize: this.tradeNum,
              beginTime: this.bushData.beginTime,
              endTime: this.bushData.endTime,
              symbol: this.bushData.symbol,
              orderType: this.bushData.orderType,
              direction: this.bushData.direction,
              platform: this.platform
            }
          }
          this.getTradeRecord(data)
        }
        if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) {
          this.entrustNum += 10
          if (this.bushData == 0 || this.bushData == 1) {
            data = {
              index: 1,
              pageSize: this.entrustNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform,
              gts2AccountId: this.gts2AccountId
            }
          } else if (this.bushData == 2) {
            data = {
              index: 1,
              pageSize: this.entrustNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform,
              gts2AccountId: this.gts2AccountId,
              orderId: this.idTxt
            }
          } else {
            data = {
              index: 1,
              pageSize: this.entrustNum,
              beginTime: this.bushData.beginTime,
              endTime: this.bushData.endTime,
              symbol: this.bushData.symbol,
              status: this.bushData.orderType,
              direction: this.bushData.direction,
              gts2AccountId: this.gts2AccountId,
              platform: this.platform
            }
          }
          this.getEntrustRecord(data)
        }
        if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) {
          this.profitAndLossNum += 10
          if (this.bushData == 0 || this.bushData == 1) {
            data = {
              index: 1,
              pageSize: this.profitAndLossNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform
            }
          } else if (this.bushData == 2) {
            data = {
              index: 1,
              pageSize: this.profitAndLossNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform,
              orderId: this.idTxt
            }
          } else {
            data = {
              index: 1,
              pageSize: this.profitAndLossNum,
              beginTime: this.bushData.beginTime,
              endTime: this.bushData.endTime,
              symbol: this.bushData.symbol,
              orderType: this.bushData.orderType,
              openDirection: this.bushData.direction,
              platform: this.platform
            }
          }
          this.getProfitAndLossRecord(data)
        }
        if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) {
          this.creditNum += 10
          if (this.bushData == 0 || this.bushData == 1) {
            data = {
              index: 1,
              pageSize: this.creditNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform,
              gts2AccountId: this.gts2AccountId
            }
          } else if (this.bushData == 2) {
            data = {
              index: 1,
              pageSize: this.creditNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform,
              gts2AccountId: this.gts2AccountId,
              orderId: this.idTxt
            }
          } else {
            data = {
              index: 1,
              pageSize: this.creditNum,
              beginTime: this.bushData.beginTime,
              endTime: this.bushData.endTime,
              reportType: this.bushData.orderType,
              gts2AccountId: this.gts2AccountId,
              platform: this.platform
            }
          }
          this.getCreditRecord(data)
        }
        if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) {
          this.stopNum += 10
          if (this.bushData == 0 || this.bushData == 1) {
            data = {
              index: 1,
              pageSize: this.stopNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform
            }
          } else if (this.bushData == 2) {
            data = {
              index: 1,
              pageSize: this.stopNum,
              beginTime: this.beginTime,
              endTime: this.endTime,
              platform: this.platform,
              orderId: this.idTxt
            }
          } else {
            data = {
              index: 1,
              pageSize: this.stopNum,
              beginTime: this.bushData.beginTime,
              endTime: this.bushData.endTime,
              symbol: this.bushData.symbol,
              orderType: this.bushData.orderType,
              direction: this.bushData.direction,
              platform: this.platform
            }
          }
          this.getStopLossRecordList(data)
        }
      }
    },
    flashReportList() {
      this.$bus.$emit('loading', false)
      this.isBrushTradePop = false
      this.report(1)
    },
    blushPop(data) {
      this.tradeDictInfo()
      this.symbolList()
      this.isReportCondition = data
      if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) this.dataCondition = this.tradeCondition
      if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) this.dataCondition = this.entrustCondition
      if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) this.dataCondition = this.profitAndLossCondition
      if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) this.dataCondition = this.creditCondition
      if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) {
        this.isReportCondition = false
        const options = {
          index: 1,
          pageSize: this.stopNum,
          beginTime: this.beginTime,
          endTime: this.endTime,
          platform: this.platform,
          orderId: data
        }
        this.getStopLossRecordList(options)
      }
    },
    changeBlushPop(data) {
      this.isBrushTradePop = data
    },
    blushConditionPop() {
      this.isReportCondition = !this.isReportCondition
      if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) this.dataCondition = this.tradeCondition
      if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) this.dataCondition = this.entrustCondition
      if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) this.dataCondition = this.profitAndLossCondition
      if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) this.dataCondition = this.creditCondition
      if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) this.dataCondition = this.stopCondition
    },
    changeConditionPop(data) {
      this.isBrushTradePop = data
      this.isReportCondition = data
    },
    tradeDictInfo() {
      const data = 'Direction,TradeOrderType,EntrustRecordOrderStatus,ProfitAndLossOrderType,FoReportType,TradeReportType'
      api.getDictInfo(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            const data = res.data.data
            this.direction = data.Direction
            if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) this.orderType = data.EntrustRecordOrderStatus
            else if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) this.orderType = data.FoReportType
            else this.orderType = data.TradeOrderType
          }
        }
      })
    },
    symbolList() {
      api.getSymbolList().then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.symbol = res.data.data.symbolList
          }
        }
      })
    },
    submit(type) {
      if (type == 0) {
        this.idTxt = ''
      } else if (type == 1) {
        this.toggleFixed()
        if ((this.idTxt != '' && this.idTxt != '请输入订单号') || this.idTxt == '') {
          this.report(2)
          this.isBrushTradePop = false
        } else {
          this.isBrushTradePop = false
        }
      }
    },
    initCondition() {
      if ((this.tabIndex == 0) || (this.typeName != '' && this.typeName == 'trades')) this.dataCondition = this.tradeCondition
      if ((this.tabIndex == 1) || (this.typeName != '' && this.typeName == 'order')) this.dataCondition = this.entrustCondition
      if ((this.tabIndex == 2) || (this.typeName != '' && this.typeName == 'profit')) this.dataCondition = this.profitAndLossCondition
      if ((this.tabIndex == 3) || (this.typeName != '' && this.typeName == 'balance')) this.dataCondition = this.creditCondition
      if ((this.tabIndex == 4) || (this.typeName != '' && this.typeName == 'stoploss')) this.dataCondition = this.stopCondition
    }
  }
}
</script>
